"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Interface for container aware injection factory.
 */
class IContainerInjection {
    /**
     * Creates instance of self with help of container.
     *
     * @param {Container} container
     */
    static create(container) {
        // Noop.
    }
}
exports.default = IContainerInjection;
